import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  fetchDraftList,
} from 'apps/web_forms/slices/appSlice';
import { APP_ROUTES } from 'apps/web_forms/utils/constants';
import { useDispatch } from 'react-redux';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

// TODO: fix this and similar hooks to share state correctly across instantiations using context/by being a context
function useDraftsMetadata() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { draftList } = useGlobalSelector();
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading]= useState(true);
  const [error, setError]= useState(false);

  useEffect(() => {
    dispatch(fetchDraftList());
  }, []);

  useEffect(() => {
    if (draftList.loading !== loading) {
      setLoading(draftList.loading);
    }

    if (draftList.data && draftList.data !== drafts) {
      setDrafts(draftList.data);
    }

    if (draftList.error) {
      setError(draftList.error);
      // TODO: Integrate Bugsnag to log the errors in prod.
      // eslint-disable-next-line no-console
      console.error('Error fetching drafts', draftList.error);
      history.push(APP_ROUTES.getErrorPageByCode(500));
    }
  }, [draftList]);

  return { drafts, loading, error };
}

export default useDraftsMetadata;
export { useDraftsMetadata };
